import React from 'react';
import PageHeader from './PageHeader';
import EmptyState from './EmptyState';

// Reason: one layout for the full-page error/not-found/offline states shared by
// TopicDetail and ArticleViewer, so the two pages cannot drift apart (design §5).
const PageErrorState = ({
  title,
  headerTitle,
  backTo,
  onBack,
  backLabel,
  icon,
  iconLabel,
  description,
  action,
}) => (
  <div className="min-h-screen bg-clay-bg">
    <PageHeader backTo={backTo} onBack={onBack} backLabel={backLabel} title={headerTitle ?? title} />
    <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8 py-8">
      <div className="card-clay-static max-w-md mx-auto">
        <EmptyState
          icon={<div className="text-6xl mb-4" role="img" aria-label={iconLabel}>{icon}</div>}
          title={title}
          description={description}
          action={action}
          className="text-center py-12 px-6"
        />
      </div>
    </div>
  </div>
);

export default PageErrorState;
